export const features = {
  MERN:"MongoDB ,Express ,React ,Node, SSR, State Management Using Redux, Tests , bundlers, eslint enabled, Dockerfile, Docker compose ",
  TMEN:"Typescript ,MongoDB ,Express , Node ,tests , eslint",
  MERNG:"MongoDB , Express , React , Node , GraphQL (Not stable yet) , SSR, State Management using Redux , eslint enabled"
}
